import { useCallback, useMemo, useState } from 'react';

import bundledFeed from '../common/constants/product_changelog.json';
import {
  countUnseen,
  getSeenIds,
  mergeEntries,
  saveSeenIds,
} from '../utils/whatsNewFeed';

// Feed for the What's New nav panel and page: the entries bundled with this
// frontend build (merged by bin/assemble_changelog --build in Amplify), newest
// first. Unseen tracking is per-browser (encrypted localStorage) by entry id —
// ids rather than timestamps because multiple releases can share a publish
// date.
export default function useWhatsNew() {
  const [seenIds, setSeenIds] = useState(getSeenIds);

  // bundledFeed is a module-scope import (stable by contract) — listing it as
  // a dependency trips react-hooks/exhaustive-deps' outer-scope-value warning.
  const entries = useMemo(() => mergeEntries(bundledFeed.entries), []);

  const unseenCount = useMemo(
    () => countUnseen(entries, seenIds),
    [entries, seenIds],
  );

  const markAllSeen = useCallback(() => {
    setSeenIds((previousIds) => saveSeenIds(previousIds, entries));
  }, [entries]);

  return { entries, unseenCount, markAllSeen };
}
